import { Grid } from "antd";
import { Trans } from "react-i18next";
import { useLayout } from "../../context/LayoutContext";
import { H4 } from "../NormalFonts";
import styles from "./styles.module.scss";

const NormalBanner = () => {
  const { getHeaderHeight } = useLayout();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <div
      className={styles.bannerContainer}
      style={{ marginTop: getHeaderHeight() }}
    >
      <H4
        weight="heavy"
        className={`${styles.bannerTitle} ${screens.md ? "" : styles.mobile}`}
      >
        <Trans
          i18nKey={
            screens.lg
              ? [
                  `home.banner.title.${process.env.REACT_APP_PROD_NAME_DEV}`,
                  "home.banner.title",
                ]
              : [
                  `home.banner.title.short.${process.env.REACT_APP_PROD_NAME_DEV}`,
                  "home.banner.title.short",
                ]
          }
        />
      </H4>
      <img
        src={`/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/top-banner.png`}
        alt="banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default NormalBanner;
